module.exports = ".breadcrumb-text {\r\n    color: #898787!important;\r\n}\r\n\r\n.breadcrumb-home {\r\n    padding-right:10px;\r\n}\r\n"